const style = {
  title: {
    variant: 'h5',
    main: {
      display: 'flex',
      justifyContent: 'space-between',
    },
    box: {
      display: 'flex',
      alignItems: 'center',
    },
    chip: {
      ml: 1,
      height: '22px',
      fontSize: '12px',
    },
    filter: {
      variant: 'body2',
      sx: {
        '&:hover': {
          cursor: 'pointer',
        },
      },
    },
  },
} as const;

export default style;
